
export enum ConnectionStatus
{
    Unset = "Unset",
    Offline = "Offline",
    Connected = "Connected",
    ConnectError = "ConnectError",
    Disconnected = "Disconnected"
}
   